import { Box, Flex, Typography, Skeleton } from "flux";
import { addDataCy } from "../../utils/dom";
import { TitleBarHeight } from "./title-bar";

interface PageHeaderProps {
  title: string;
  description?: string;
  subDescription?: string;
  descriptionLoading?: boolean;
  testId?: string;
  showSubDescriptionOnHeader?: boolean;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  subDescription,
  descriptionLoading = false,
  testId,
  showSubDescriptionOnHeader = true
}) => {
  return (
    <>
      <Box zIndex={10} pb="24px" mx="calc(var(--page-padding) * -1)" bgcolor="background.default">
        <Flex justifyContent="center" pb="12px" {...addDataCy(testId)}>
          <Typography variant="h1" color="textPrimary" className="!text-4xl @3xl/app-content:!text-5xl">
            {title}
          </Typography>
        </Flex>
        <Flex justifyContent={"center"}>
          {descriptionLoading ? (
            <Skeleton variant="text" width={600} height={20} sx={{ maxWidth: "calc(100% - 32px)" }} />
          ) : (
            <Typography variant="body2" color="textSecondary" align="center" width="600px" maxWidth="100%">
              {description}
            </Typography>
          )}
        </Flex>
        {showSubDescriptionOnHeader && subDescription && (
          <Flex justifyContent={"center"}>
            <Typography variant="body2" color="textSecondary" align="center" width="525px" maxWidth="100%">
              {subDescription}
            </Typography>
          </Flex>
        )}
      </Box>
      {/* Sticky title. Note the negative top margin, which is what causes this to scroll into place */}
      <Flex
        justifyContent="center"
        alignItems="center"
        position="sticky"
        height={`${TitleBarHeight + 1}px`}
        mt={`-${TitleBarHeight + 1}px`}
        top={0}
        zIndex={5}
        mx="calc(var(--page-padding) * -1)"
        borderBottom="1px solid"
        borderColor="divider"
        bgcolor="background.default"
        sx={{
          "@media print": {
            display: "none"
          }
        }}
      >
        <Box bgcolor="background.default">
          <Flex justifyContent={"center"}>
            <Typography variant="h6" color="textPrimary">
              {title}
            </Typography>
          </Flex>
          {subDescription && (
            <Flex justifyContent={"center"}>
              <Typography variant="body2" color="textSecondary" align="center" width="525px" maxWidth="100%">
                {subDescription}
              </Typography>
            </Flex>
          )}
        </Box>
      </Flex>
    </>
  );
};

export default PageHeader;
